import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed, ref as _ref } from 'vue';

import { DataItemProps } from 'vuetify';
import type { DataProductUpstreamIncidentDto, IncidentCatalogAssetDto, IncidentLightDto } from '@/api';
import fromNow from '@/utils/filters/fromNow';
import IncidentStatus from '@/components/incidents/Incident-Status.vue';
import IncidentIcon from '@/modules/incidents/incident/components/IncidentIcon.vue';
import { INCIDENT_ROUTE_NAMES } from '@/router/components';
import SAvatars from '@/components/SAvatars/SAvatars.vue';
import IncidentRestrictedAccessModal from '@/modules/incidents/incident/components/IncidentRestrictedAccessModal.vue';

type IncidentResultsCardItem =
  | IncidentCatalogAssetDto
  | IncidentLightDto
  | DataProductUpstreamIncidentDto;

interface IncidentResultsCardProps {
  itemProps: Omit<DataItemProps, 'item'> & { item: IncidentResultsCardItem },
  selectable?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Incidents-Results-Card',
  props: {
  itemProps: null,
  selectable: { type: Boolean, default: true }
},
  setup(__props) {

const props = __props;


const lastFailureLabel = _computed(() => fromNow(props.itemProps.item.lastOccurredDate));
const isDataProductUpstreamIncident = (
  item: IncidentResultsCardItem,
): item is DataProductUpstreamIncidentDto => 'accessAuthorized' in item;
const isRestricted = _computed(() => isDataProductUpstreamIncident(props.itemProps.item)
  && props.itemProps.item.accessAuthorized === false);
const qualification = _computed(() => (
  isDataProductUpstreamIncident(props.itemProps.item)
    ? undefined
    : props.itemProps.item.qualification
));
const incidentLink = _computed(() => ({
  name: INCIDENT_ROUTE_NAMES.overview,
  params: {
    issue: String(props.itemProps.item.issueNo),
    name: String(props.itemProps.item.name),
  },
}));

const restrictedAccessModal = _ref<InstanceType<typeof IncidentRestrictedAccessModal> | null>(null);
const restrictedDomainNames = _computed(() => (
  isDataProductUpstreamIncident(props.itemProps.item)
    ? (props.itemProps.item.associatedDomainNames ?? null)
    : null
));

const onCardClick = () => {
  if (!isRestricted.value) return;
  restrictedAccessModal.value?.openModal();
};

// Merge assignees and teams into a single array.
// Respect backwards compatibility: manage both assignees and owners.
const mergedOwners = _computed(() => [
  ...(props.itemProps.item as IncidentCatalogAssetDto).assignees ?? [],
  ...(props.itemProps.item as IncidentLightDto).owners ?? [],
  ...(props.itemProps.item.teams ?? []).map((team) => ({ ...team, type: 'TEAM' })),
]);

return { __sfc: true,props, lastFailureLabel, isDataProductUpstreamIncident, isRestricted, qualification, incidentLink, restrictedAccessModal, restrictedDomainNames, onCardClick, mergedOwners, _computed, _ref, DataItemProps, fromNow, IncidentStatus, IncidentIcon, INCIDENT_ROUTE_NAMES, SAvatars, IncidentRestrictedAccessModal }
}

})